import { AUTH_POST } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";

let apiAbortController: AbortController | null = null;

const getLeadsByAdvancedFilter = async (limit: number, skip: number, rules: any[], searchKey?: string | null): Promise<any> => {
  // console.log("🚀 ~ limit:", limit)
  // console.log("🚀 ~ skip:", skip)
  // console.log("🚀 ~ rules:", rules)
  // Cancel previous request if it exists
  if (apiAbortController) {
    apiAbortController.abort();
  }

  // Create a new AbortController for the current request
  apiAbortController = new AbortController();
  try {
    const url = new URL("/api/leads/advanced-filter", config.baseURL);
    // if (limit && limit !== null && !isNaN(limit)) {
    //     url.searchParams.append("limit", limit.toString());
    // }
    // if (skip && skip !== null && !isNaN(skip)) {
    //     url.searchParams.append("skip", skip.toString());
    // }

    const tags = ["leads", `limit:${limit.toString()}`, `skip:${skip.toString()}`, `rules:${JSON.stringify(rules)}`, `searchKey:${searchKey}`];

    const requestData: any = {
      rules: rules,
      condition: "AND",
      limit: Number(limit) || 10,
      skip: skip || 0,
      sortBy: "CREATED_AT",
      sortOrder: "desc",
    };

    if (searchKey) {
      requestData["search"] = searchKey;
    }

    const response = await AUTH_POST(url.toString(), requestData, {
      revalidate: 30,
      tags: tags,
      signal: apiAbortController?.signal,
    });
    apiAbortController = null; // Clear the controller after successful request

    return response;
  } catch (error: any) {
    console.log({ error });
    if (error.name === "AbortError") {
      // Handle fetch cancellation
      console.log("Fetch request canceled");
    } else {
      // Handle other errors
      throw error;
    }
  }
};

export default getLeadsByAdvancedFilter;
